import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import styles from './CreateImplantModal.module.scss';
import Modal from '../Shared/Modal/Modal';
import { Button } from '../Shared/Buttons';
import { AlertBox } from '../Shared/Alerts';
import * as patientActions from '../../redux/actions/patientActions';
import * as referenceDataActions from '../../redux/actions/referenceDataActions';
import ImplantSelector from './ImplantSelector';
import DataItem from '../Shared/DataItem/DataItem';
import { toastrOptions } from '../../constants/toastrOptions';

class CreateImplantModal extends Component {
  constructor(props) {
    super(props);
    this.intl = props.intl;

    this.state = {
      dataId: -1,
      abutmentId: -1,
      implantLot: '',
      abutmentLot: '',
      errorMessages: undefined,
      currentImplant: undefined,
      isStudyTreatment: false,
      studyImplants: [],
      studyAbutments: [],
    };

    this.settingImplantData = false;
    this.deletingImplantData = false;

    this.hideSetImplantDataModal = this.hideSetImplantDataModal.bind(this);
    this.saveImplant = this.saveImplant.bind(this);
    this.renderImplants = this.renderImplants.bind(this);
    this.renderAbutments = this.renderAbutments.bind(this);
    this.implantLotChanged = this.implantLotChanged.bind(this);
    this.abutmentLotChanged = this.abutmentLotChanged.bind(this);
    this.getStudyImplantsAndAbutments = this.getStudyImplantsAndAbutments.bind(this);
  }

  componentDidMount() {
    if (!this.props.implants || this.props.implants.length === 0) {
      this.props.actions.getImplantData(true);
    }
    if (!this.props.abutments || this.props.abutments.length === 0) {
      this.props.actions.getAbutmentData(true);
    }
    if (!this.props.usedImplants) {
      this.props.actions.getUsedImplants();
    }
    if (!this.props.studyImplantData || this.props.studyImplantData.length === 0) {
      this.props.actions.getStudyImplantData();
    }
    if (!this.props.studyAbutmentData || this.props.studyAbutmentData.length === 0) {
      this.props.actions.getStudyAbutmentData();
    }

    // get study implants and abutments if its a study tooth
    var studiesOfSelectedTooth = this.props.currentImplant.find(
      (implant) => implant.tooth === this.props.selectedImplant
    )?.studyGroups;
    if (studiesOfSelectedTooth !== undefined && studiesOfSelectedTooth.length > 0) {
      this.getStudyImplantsAndAbutments(studiesOfSelectedTooth, this.props.abutment);
    }

    this.props.actions.getUsedImplants();

    if (this.props.implant) {
      this.setState({
        abutmentId: this.props.implant.abutmentId,
        dataId: this.props.implant.dataId,
        implantLot: this.props.implant.implantLot ?? '',
        abutmentLot: this.props.implant.abutmentLot ?? '',
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.setImplantData.complete && this.settingImplantData) {
      this.setState({
        showSaveMenu: false,
      });
      this.settingImplantData = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({ id: 'implant.implantSaved', defaultMessage: 'Implant saved' }),
        toastrOptions
      );
      this.hideSetImplantDataModal();
    }
  }

  getStudyImplantsAndAbutments(studiesOfSelectedTooth, nextPropsAbutment) {
    var studyGroupsOfUser = this.props.studyGroupsOfUser;

    var studyImplantToGet = [];
    var stydyAbutmentToGet = [];

    // Loop through studies of selected tooth and study groups of the user.
    // If we find a match add studyImplants/studyAbutments to variables above.
    for (let i = 0; i < studiesOfSelectedTooth.length; i++) {
      for (let j = 0; j < studyGroupsOfUser.length; j++) {
        if (studiesOfSelectedTooth[i].id === studyGroupsOfUser[j].id) {
          studyImplantToGet = [...studyImplantToGet, ...studyGroupsOfUser[j].studyImplants];
          stydyAbutmentToGet = [...stydyAbutmentToGet, ...studyGroupsOfUser[j].studyAbutments];
        }
      }
    }

    if (nextPropsAbutment && stydyAbutmentToGet.length > 0) {
      var studyAbutmentToDropDown = [];
      stydyAbutmentToGet.forEach((id) => {
        var abutment = this.props.studyAbutmentData.find((abutment) => abutment.dataId === id);
        studyAbutmentToDropDown.push(abutment);
      });

      this.setState({
        isStudyTreatment: true,
        studyAbutments: studyAbutmentToDropDown,
      });
    } else if (!nextPropsAbutment && studyImplantToGet.length > 0) {
      var studyImplantsToDropDown = [];
      studyImplantToGet.forEach((id) => {
        var implant = this.props.studyImplantData.find((implant) => implant.dataId === id);
        studyImplantsToDropDown.push(implant);
      });

      this.setState({
        isStudyTreatment: true,
        studyImplants: studyImplantsToDropDown,
      });
    } else {
      this.setState({ isStudyTreatment: false });
    }
  }

  hideSetImplantDataModal() {
    this.resetState();
    if (this.props.hide) {
      this.props.hide();
    }
  }

  saveImplant() {
    if (this.props.selectedImplant <= 0) return;

    this.settingImplantData = true;
    this.props.actions.setImplantData(
      this.props.patient.sourceUserGroupId,
      this.props.patient.id,
      this.props.selectedImplant,
      this.state.dataId,
      this.state.abutmentId,
      this.state.implantLot,
      this.state.abutmentLot
    );
  }

  onImplantSelected(id) {
    this.setState({
      dataId: id,
    });
  }

  onAbutmentSelected(id) {
    this.setState({
      abutmentId: id,
    });
  }

  setErrorMessages(errorMessageArray) {
    this.setState({ errorMessages: errorMessageArray });
  }

  resetState() {
    this.setState({
      dataId: -1,
      abutmentId: -1,
      implantLot: '',
      abutmentLot: '',
      errorMessages: undefined,
      isStudyTreatment: false,
      studyImplants: [],
      studyAbutments: [],
    });
  }

  implantLotChanged(evt) {
    this.setState({
      implantLot: evt.target.value,
    });
  }

  abutmentLotChanged(evt) {
    this.setState({
      abutmentLot: evt.target.value,
    });
  }

  renderImplants() {
    if (this.props.implants && this.props.implants.length > 0) {
      let implant = this.state.isStudyTreatment
        ? this.state.studyImplants.find((x) => x.dataId === Number(this.state.dataId))
        : this.props.implants.find((x) => x.dataId === Number(this.state.dataId));

      if (!implant) implant = {};
      var implantsToShow = this.state.isStudyTreatment
        ? this.state.studyImplants
        : this.props.implants;

      return (
        <div className={styles.content}>
          <div className={styles.column}>
            <ImplantSelector
              study={this.state.isStudyTreatment}
              implants={implantsToShow}
              usedImplants={this.props.usedImplants}
              dataId={this.state.dataId}
              onImplantSelected={this.onImplantSelected.bind(this)}
              selectedTabIndex={this.state.selectedTabIndex}
              lot={this.state.implantLot}
              lotChanged={this.implantLotChanged}
              setErrorMessages={this.setErrorMessages.bind(this)}
              resetImplantModalState={this.resetState.bind(this)}
              type="implant"
              userId={this.props.user.id}
              email={this.props.user.email}
            />
          </div>
          <div className={styles.column}>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({ id: 'implant.model', defaultMessage: 'Model' })}
                value={implant.modelName}
                span
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.platform',
                  defaultMessage: 'Platform',
                })}
                value={implant.platformName}
              />
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.artNumber',
                  defaultMessage: 'Article number',
                })}
                value={implant.partNumber}
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.diameter',
                  defaultMessage: 'Diameter',
                })}
                value={implant.diameter}
              />
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.lenth',
                  defaultMessage: 'Length (mm)',
                })}
                value={implant.length}
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.suitableSmartPeg',
                  defaultMessage: 'Suitable single-use SmartPeg',
                })}
                value={implant.smartPeg}
                span
              />
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.suitableReusableSmartPeg',
                  defaultMessage: 'Suitable reusable SmartPeg',
                })}
                value={implant.smartPegR}
                span
              />
            </div>
          </div>
        </div>
      );
    }
  }

  renderAbutments() {
    if (this.props.implants && this.props.implants.length > 0) {
      let implant = this.state.isStudyTreatment
        ? this.state.studyAbutments.find((x) => x.dataId === Number(this.state.abutmentId))
        : this.props.abutments.find((x) => x.dataId === Number(this.state.abutmentId));
      if (!implant) implant = {};
      var abutmentsToShow =
        this.state.isStudyTreatment === true ? this.state.studyAbutments : this.props.abutments;
      return (
        <div className={styles.content}>
          <div className={styles.column}>
            <ImplantSelector
              study={this.state.isStudyTreatment}
              abutment
              implants={abutmentsToShow}
              usedImplants={this.props.usedAbutments}
              dataId={this.state.abutmentId}
              onImplantSelected={this.onAbutmentSelected.bind(this)}
              lot={this.state.abutmentLot}
              lotChanged={this.abutmentLotChanged}
              setErrorMessages={this.setErrorMessages.bind(this)}
              resetImplantModalState={this.resetState.bind(this)}
              type="abutment"
              userId={this.props.user.id}
              email={this.props.user.email}
            />
          </div>
          <div className={styles.column}>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({ id: 'implant.model', defaultMessage: 'Model' })}
                value={implant.modelName}
                span
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.platform',
                  defaultMessage: 'Platform',
                })}
                value={implant.platformName}
              />
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.artNumber',
                  defaultMessage: 'Article number',
                })}
                value={implant.partNumber}
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.diameter',
                  defaultMessage: 'Diameter',
                })}
                value={implant.diameter}
              />
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.lenth',
                  defaultMessage: 'Length (mm)',
                })}
                value={implant.length}
              />
              <DataItem
                label={this.intl.formatMessage({ id: 'implant.angle', defaultMessage: 'Angle' })}
                value={implant.angle}
              />
            </div>
            <div className={styles.dataRow}>
              <DataItem
                label={this.intl.formatMessage({
                  id: 'implant.suitableSmartPeg',
                  defaultMessage: 'Suitable SmartPeg',
                })}
                value={implant.smartPeg}
                span
              />
            </div>
          </div>
        </div>
      );
    }
  }

  disableSave() {
    return !(
      (this.props.abutment && this.state.abutmentId > 0) ||
      (!this.props.abutment && this.state.dataId > 0)
    );
  }

  render() {
    const header = this.props.abutment
      ? this.intl.formatMessage({
          id: 'addimplant.addAbutment',
          defaultMessage: 'Add Abutment',
        })
      : this.intl.formatMessage({
          id: 'addimplant.addImplant',
          defaultMessage: 'Add Implant',
        });

    const error = this.props.setImplantData.error || this.state.errorMessages;
    return (
      <Modal
        modalPanelClass={styles.modalPanel}
        header={header}
        onDismiss={this.hideSetImplantDataModal}
        show={this.props.show}
      >
        {error ? (
          <AlertBox
            color="black"
            headerText={this.intl.formatMessage({
              id: 'general.generalError',
              defaultMessage: 'Oops, there was an error',
            })}
            messages={error.messages.map((m) => m.text)}
          />
        ) : null}
        {this.props.abutment ? this.renderAbutments() : this.renderImplants()}
        <div className={styles.buttons}>
          <Button
            centered
            value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
            onClick={() => this.hideSetImplantDataModal()}
            leftIcon="back"
          />
          <Button
            primary
            value={this.intl.formatMessage({ id: 'general.save', defaultMessage: 'Save' })}
            onClick={this.saveImplant}
            disabled={this.creatingImplantData || this.disableSave()}
            loading={this.creatingImplantData}
          />
        </div>
      </Modal>
    );
  }
}

function mapState(state) {
  return {
    user: state.user.user,
    setImplantData: state.patient.setImplantData,
    patient: state.patient.currentPatient,
    selectedImplant: state.patient.selectedPatientImplant,
    implants: state.referenceData.implantData,
    abutments: state.referenceData.abutmentData,
    smartPegs: state.referenceData.smartPegData,
    usedImplants: state.patient.usedImplants,
    usedAbutments: state.patient.usedAbutments,
    currentImplant: state.patient.currentImplants,
    studyGroupsOfUser: state.studyGroup.studyGroups,
    studyImplantData: state.referenceData.studyImplantData,
    studyAbutmentData: state.referenceData.studyAbutmentData,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators({ ...patientActions, ...referenceDataActions }, dispatch),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(CreateImplantModal));
